module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "engineer-page"
  }, [_c('h3', {
    staticClass: "page-title3"
  }, [_vm._v("工程师维护")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.handleOpenDialog()
      }
    }
  }, [_vm._v("新增工程师")]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工程师名称"
    }
  }, [_c('el-input', {
    staticClass: "item-input",
    attrs: {
      "placeholder": "请输入工程师名称"
    },
    nativeOn: {
      "click": function($event) {
        _vm.getEngineer($event)
      }
    },
    model: {
      value: (_vm.Search.Name),
      callback: function($$v) {
        _vm.Search.Name = $$v
      },
      expression: "Search.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办事处"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "options": _vm.Provinces,
      "clearable": "",
      "props": {
        value: 'Id',
        label: 'Name',
        children: 'children'
      },
      "placeholder": "请选择办事处（省/市/区）"
    },
    on: {
      "active-item-change": _vm.handleItemChange
    },
    model: {
      value: (_vm.Search.Place),
      callback: function($$v) {
        _vm.Search.Place = $$v
      },
      expression: "Search.Place"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": _vm.getEngineer
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "table-shin-expand",
    attrs: {
      "loading": _vm.IsLoading,
      "element-loading-text": "加载中",
      "data": _vm.Engineers
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "inner-form",
          attrs: {
            "inline": true,
            "label-width": "120px",
            "label-suffix": "："
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "身份证"
          }
        }, [_vm._v(_vm._s(props.row.IdCard))]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邮箱"
          }
        }, [_vm._v(_vm._s(props.row.Email))]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "电话"
          }
        }, [_vm._v(_vm._s(props.row.Mobile))]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "QQ"
          }
        }, [_vm._v(_vm._s(props.row.QQ))]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "微信"
          }
        }, [_vm._v(_vm._s(props.row.Weixin))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "编号",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工程师名称",
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "办事处",
      "width": "300px",
      "prop": "StreetAddress"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleOpenDialog(props.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticClass: "danger",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleRemoveEngineer(props.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('engineer-dialog', {
    attrs: {
      "name": "engineer",
      "show": _vm.Dialog.show,
      "title": _vm.Dialog.Form.Id ? '编辑工程师' : '新增工程师',
      "form": _vm.Dialog.Form
    },
    on: {
      "update:show": function($event) {
        _vm.Dialog.show = $event
      },
      "confirm": _vm.handleEngineerConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f4fae5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ProfilePage/EngineerModule.vue
// module id = 747
// module chunks = 0